import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../../styles/components/LoadingState.module.css';

function LoadingState({ text, compact = false }) {
  const { t } = useTranslation();
  const resolvedText = text !== undefined ? text : t('loadingState.defaultText');
  const classes = [styles.loadingState, compact && styles.compact].filter(Boolean).join(' ');

  return (
    <div className={classes}>
      <div className={styles.spinner} />
      {resolvedText && <p className={styles.text}>{resolvedText}</p>}
    </div>
  );
}

export default LoadingState;
